import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.3 7.778a2.25 2.25 0 0 0-2.503 1.471.75.75 0 1 1-1.415-.498 3.75 3.75 0 0 1 7.288 1.25c0 1.397-1.039 2.343-1.834 2.873a7.8 7.8 0 0 1-1.631.821l-.033.011-.01.004h-.003l-.001.001-.238-.71.237.71a.75.75 0 0 1-.476-1.422l.003-.001.018-.006.08-.03a6.295 6.295 0 0 0 1.222-.626c.705-.47 1.166-1.024 1.166-1.626V10a2.25 2.25 0 0 0-1.87-2.221",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 16.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-10 8.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }